import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useHistory } from "react-router";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import TenantService from "api/tenant.service";
import AssetsService from "api/assets.service";
import FeaturesService from "api/features.service";
import { LoadPanel as LoadingPanel } from 'devextreme-react/load-panel';
import Toast from 'components/Toast';
import moment from 'moment-timezone';
import { SelectBox } from 'devextreme-react';
import { DateBox } from 'devextreme-react/date-box';
import './assetTab.css'
import AssetViewMultiple from "./assetMultiple"
import UtilizationHeatMap from "./utilizationHeatMap";
import MechanicalHeatMap from "./mechanicalHeatMap";
import CheckBox from 'devextreme-react/check-box';
import {
    DropDownShockThreshold,
    MergedChart,
    EditTab,
    ActionsTab,
    // DropDownTemperature,
    // TemperatureChart,
    CyclesChart,
} from './mechnicalAttributes';

export default function App(props) {
    const tabPanelRef = useRef(null);
    const ids = useMemo(() => {
        return props.location.state?.id ?? [];
      }, [props.location.state?.id]);
    console.log("ids", ids)
    const names = useMemo(() => {
        return props.location.state?.name ?? [];
      }, [props.location.state?.name]); // Only re-calculate if the specific property changes
      console.log("names", names)
    const tenant = TenantService.getTenant();
    const [isUtilizationVisible, setIsUtilizationVisible] = useState(false);
    const [isTelemetryVisible, setIsTelemetryVisible] = useState(false);
    const [checkAutoUpdate, setCheckAutoUpdate] = useState(false);
    const intervalRef = useRef(null);
    const WAIT_TIME = 10000;
    // const utilizationVisible = FeaturesService.getTenantModule(tenant, 1).then((value) => {
    //     console.log("utilizationVisible",value)
    //   })
    // console.log("utilizationVisible",utilizationVisible)


    const storageKey = `${tenant}-util-filter`;
    // const assetId = ids[0]
    const [startDate, setStartDate] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
            const filters = JSON.parse(saved);
            return filters.startDate ? filters.startDate : null;
        }
        return moment().subtract(24, 'hours').format();; // Default if nothing exists
    });
    const [endDate, setEndDate] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
            const filters = JSON.parse(saved);
            return filters.endDate ? filters.endDate : null;
        }
        return moment().format();; // Default if nothing exists
    });
    const [selectedPeriod, setSelectedPeriod] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
            const filters = JSON.parse(saved);
            return filters.selectedPeriod ? filters.selectedPeriod : 'Last 24 hours';
        } else {
            return 'Last 24 hours'
        }
    });
    // const [selectedSpace2, setSelectedSpace2] = useState(() => {
    //     const saved = localStorage.getItem(storageKey);
    //     if (saved) {
    //         const filters = JSON.parse(saved);
    //         console.log("filters.selectedSpace", filters.selectedSpace)
    //         return filters.selectedSpace ? filters.selectedSpace : null;
    //     }
    //     return null; // Default if nothing exists
    // });
    const [selectedSpace2, setSelectedSpace2] = useState()
    const [types, setTypes] = useState([]);
    const [pageName, setPageName] = useState("");
    const [editAllowed, setEditAllowed] = useState(false);
    const [popupVisible, setPopupVisible] = useState(false);
    const [editedFlag, setEditedFlag] = useState(false);
    const [lastPositionUpdateTime, setLastPositionUpdateTime] = useState("");
    const [latestDwellTime, setLatestDwellTime] = useState("");
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [floorplanGeo, setFloorplanGeo] = useState(false)
    const [filters, setFilters] = useState([]);
    const [spaces, setSpaces] = useState([]);

    const [loading, setLoading] = useState(false);
    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000,
    });
    const history = useHistory();
    console.log("hgfyhtdf")
    console.log("ids2", ids)
    if (ids.length === 0){
        goBack()
    }

    useEffect(() => {
        // Only fetch once when the component mounts
        FeaturesService.getTenantFeature(tenant, 2)
            .then((result) => {
                let isDeviceFeature = result.data.data
                if (isDeviceFeature === false){
                    setIsUtilizationVisible(true);
                }
                console.log("util", isDeviceFeature)
                // setIsLoading(false);
            })
            .catch((err) => {
                console.error("Failed to fetch module access", err);
                // setIsLoading(false);
            });
        FeaturesService.getTenantFeature(tenant, 3)
            .then((result) => {
                let isDeviceFeature = result.data.data
                // console.log("telem1", result)
                if (isDeviceFeature === true) {
                    FeaturesService.getTenantFeature(tenant, 4)
                        .then((result) => {
                            let isDeviceFeature2 = result.data.data
                            if (isDeviceFeature2 === false){
                                setIsUtilizationVisible(true);
                            }
                            // console.log("telem", isDeviceFeature)
                            // setIsLoading(false);
                        })
                        .catch((err) => {
                            console.error("Failed to fetch module access", err);
                            // setIsLoading(false);
                        });
                } else if (isDeviceFeature === false){
                    setIsTelemetryVisible(true);
                } else { //isDeviceFeature = null
                    setIsTelemetryVisible(false);
                }
            })
            .catch((err) => {
                console.error("Failed to fetch module access", err);
                // setIsLoading(false);
            });
    }, [tenant]); // Only re-run if the tenant changes

    function checkRole() {
        var role = JSON.parse(localStorage.getItem("role"));
        let canEdit = false
        for (let i = 0; i < role.length; i++) {
            if (role[i].name === "Asset Attributes") {
                if (role[i].write === true) {
                    canEdit = true
                }
            }
        }
        if (canEdit) {
            setEditAllowed(true)
        }
    }

    function getTypes() {
        AssetsService.getAssetTenantTypes(tenant).then((value) => {
            let response = value.data
            setTypes(response.data)
        })
    }

    function goBack() {
        history.push({
            pathname: `/assets/`,
            state: {
                response: ""
            }
        })
    }

    useEffect(() => {
        getTypes()
        checkRole()
    }, []);

    useEffect(() => {
    }, [types]);

    function onSave() {
        if (editedFlag) {
            setPopupVisible(true)
        } else {
            goBack()
        }
    }

    const handleStartDateChange = async (value) => {
        console.log("handleStartDateChange")
        setStartDate(value);
        setSelectedPeriod('Custom');
    };

    const handleEndDateChange = async (value) => {
        setEndDate(value);
        setSelectedPeriod('Custom');
    };

    const handlePeriodChange = async (value) => {
        if (value !== 'Custom') {
            let start, end;
            switch (value) {
                case 'Last 24 hours':
                    start = moment().subtract(24, 'hours').format();
                    end = moment().format();
                    break;
                case 'Today':
                    start = moment().startOf('day').format();
                    end = moment().format();
                    break;
                case 'Last 5 min':
                    start = moment().subtract(5, 'minutes').format();
                    end = moment().format();
                    break;
                case 'Last 20 min':
                    start = moment().subtract(20, 'minutes').format();
                    end = moment().format();
                    break;
                case 'Last 1 hour':
                    start = moment().subtract(1, 'hour').format();
                    end = moment().format();
                    break;
                case 'Last 4 hours':
                    start = moment().subtract(4, 'hours').format();
                    end = moment().format();
                    break;
                case 'Last 12 hours':
                    start = moment().subtract(12, 'hours').format();
                    end = moment().format();
                    break;
                case 'Yesterday':
                    start = moment().subtract(1, 'day').startOf('day').format();
                    end = moment().subtract(1, 'day').endOf('day').format();
                    break;
                case 'This Week':
                    start = moment().startOf('week').format();
                    end = moment().format();
                    break;
                case 'Last Week':
                    start = moment().subtract(1, 'weeks').startOf('week').format();
                    end = moment().subtract(1, 'weeks').endOf('week').format();
                    break;
                case 'This Month':
                    start = moment().startOf('month').format();
                    end = moment().format();
                    break;
                case 'Last Month':
                    start = moment().subtract(1, 'month').startOf('month').format();
                    end = moment().subtract(1, 'month').endOf('month').format();
                    break;
                case 'Last 7 days':
                    start = moment().subtract(7, 'days').format();
                    end = moment().format();
                    break;
                default:
                    break;
            }
            setStartDate(start);
            setEndDate(end);
            setSelectedPeriod(value);
        }
    };

    function submitOk() {
        if (moment(endDate).isAfter(moment(startDate))) {
            let filter = {
                "selectedPeriod": selectedPeriod,
                "startDate": startDate,
                "endDate": endDate,
                "selectedSpace": selectedSpace2
            }
            localStorage.setItem(`${tenant}-util-filter`, JSON.stringify(filter));
            setFilters(filter)
        } else {
            console.log('add toast here! End date should be after Start date', "startDate, endDate", startDate, endDate);
        }
    }

    //     useEffect(() => {
    //     const getSpaces = () => {
    //       const from = startDate;
    //       const to = endDate;
    //       console.log('from,to', from, to);
    //       if (from != null && to != null) {
    //         if (from < to) {
    //           AssetsService.locationHistory(assetId, from, to, null, 'asset').then((value) => {
    //             // @@@ add spinner here
    //             if (value?.data?.data?.floorplans?.length !== 0) {
    //               setSelectedSpace2(value?.data?.data?.floorplans[0]?.id);
    //             } else {
    //               console.log('No floorplan');
    //             }
    //             setSpaces(value?.data?.data?.floorplans);
    //           });
    //         } else {
    //           console.log('add toast here! End date should be after Start date');
    //         }
    //       } else {
    //         console.log('null!!');
    //       }
    //     };
    //     getSpaces();
    //   }, [startDate, endDate, assetId]);

    useEffect(() => {
        // 1. THE GUARD CLAUSE
        // This prevents the API call if any required value is missing
        if (!startDate || !endDate || !ids || !selectedPeriod) {
            console.log("Waiting for all filters to have values...");
            return;
        }
        const getSpaces = () => {
            const from = startDate;
            const to = endDate;
            // 2. LOGIC VALIDATION
            if (from < to) {
                console.log('Fetching history for:', from, to);
                // @@@ add spinner here (e.g., setIsLoading(true))
                AssetsService.getFloorplanIds(ids, from, to)
                    .then((value) => {
                        let currentSpaces = value.data.data
                        console.log("currentSpaces", currentSpaces)
                        // currentSpaces.push({
                        //     id: "6a21bf9e-fc6b-4bec-9f5c-8f8297772091",
                        //     name: "Geo Map"
                        // })
                        // const floorplans = value?.data?.data?.floorplans || [];
                        // if (floorplans.length !== 0) {
                        //   // Only set a default if one isn't already selected
                        //   console.log("floorplans", floorplans)

                        // } else {
                        //   console.log('No floorplan found for this range');
                        // }
                        if (currentSpaces.length > 0) {
                            setSpaces(currentSpaces);
                            setSelectedSpace2(currentSpaces[0].id);
                        }

                    })
                    .finally(() => {
                        // @@@ remove spinner here
                    });
            } else {
                // Use your Toast logic here
                console.error('Validation Error: End date must be after start date');
            }
        };
        getSpaces();
        // 3. DEPENDENCY ARRAY
        // Added selectedPeriod here so it re-fires if the user changes the timeframe
    }, [startDate, endDate, ids, selectedPeriod]);

    function onFloorplanValueChanged(e) {
        if (e.value === "6a21bf9e-fc6b-4bec-9f5c-8f8297772091") {
            setFloorplanGeo(true)
        } else {
            setFloorplanGeo(false)
        }
        setSelectedSpace2(e.value)
        // getData(e.value)
    }

    function onAutoUpdateValueChange(e) {
        console.log("e", e)
        if (e.value) {
            let filter = {
                "selectedPeriod": selectedPeriod,
                "startDate": startDate,
                "endDate": moment().format(),
                "selectedSpace": selectedSpace2
            }
            localStorage.setItem(`${tenant}-util-filter`, JSON.stringify(filter));
            setFilters(filter)
            setCheckAutoUpdate(!checkAutoUpdate)

        }
    }


    // const onAutoUpdateValueChange = useCallback((args) => {
    //     const periodVal = localStorage.getItem(`${tenant}dateFilterText`);
    //     if (periodVal !== 'Yesterday' && periodVal !== 'Last Week' && periodVal !== 'Last Month') {
    //       setCheckAutoUpdate(args.value)
    //     } else {
    //       setCheckAutoUpdate(false)
    //       setIsDisableAutoUpdate(true)
    //     }
    //   }, []);


    useEffect(() => {
        const startAutoUpdate = () => {
            intervalRef.current = setInterval(() => {
                console.log("testing")
                setEndDate(moment().format())
                // const periodVal = localStorage.getItem(`${tenant}dateFilterText`);
                // if (periodVal !== 'Yesterday' && periodVal !== 'Last Week' && periodVal !== 'Last Month') {
                //   if (periodVal === 'Custom') {
                //     const callAPIForCustom = isEndDateWithinLastThreeMinutes(endDate)
                //     if (callAPIForCustom) {
                //       handleValueChangeRecursive(periodVal);
                //       getData(selectedSpace2);
                //     }
                //   } else {
                //     handleValueChangeRecursive(periodVal);
                //     getData(selectedSpace2);
                //   }
                // }
            }, WAIT_TIME);
        };
        const stopAutoUpdate = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
        if (checkAutoUpdate) {
            stopAutoUpdate(); // Clear any previous intervals to avoid duplicates
            startAutoUpdate();
        } else {
            stopAutoUpdate();
        }
        // Cleanup on unmount
        return () => stopAutoUpdate();
    }, [checkAutoUpdate, selectedSpace2]);

    useEffect(() => {
        submitOk()
    }, [endDate, selectedSpace2]);


    useEffect(() => {
        if (selectedPeriod !== "Custom"){
            setCheckAutoUpdate(false)
        }
        submitOk()
    }, [selectedPeriod]);

    useEffect(() => {
        setCheckAutoUpdate(false)
        submitOk()
    }, [startDate]);

    useEffect(() => {
        console.log("names",names)
    }, [names]);


    return (
        <>
            <div className='topBarAssetTab'>
                <div className='titleAsset' >
                    {/* <b>Asset: {names.join(', ')}</b> &nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}>Last Position Update: {lastPositionUpdateTime}</span>&nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}>Dwell time in current space: {latestDwellTime}</span> */}
                    <b>Asset: {names.join(', ')}</b> &nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}></span>
                </div>
                <div className='backBtn' onClick={onSave}>
                    <i className="dx-icon-close"></i>
                </div>
            </div>
            <div className="btnContainerDateTime">
                <div className="dateBtn">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SelectBox
                            style={{ marginRight: '10px', width: '20%' }}
                            dataSource={[
                                'Today',
                                'Last 5 min',
                                'Last 20 min',
                                'Last 1 hour',
                                'Last 4 hours',
                                'Last 12 hours',
                                'Last 24 hours',
                                'Yesterday',
                                'This Week',
                                'Last Week',
                                'This Month',
                                'Last Month',
                                'Last 7 days',
                                'Custom',
                            ]}
                            value={selectedPeriod}
                            onValueChanged={(e) => handlePeriodChange(e.value)}
                            labelMode="static"
                            label="Period"
                            stylingMode="outlined"
                        />
                        <DateBox
                            style={{ marginRight: '10px' }}
                            type="datetime"
                            value={startDate}
                            onValueChanged={async (e) => await handleStartDateChange(e.value)}
                            placeholder="Start Date"
                            labelMode="static"
                            label="Start Date"
                            stylingMode="outlined"
                            displayFormat="yyyy-MM-dd HH:mm"
                            valueFormat="yyyy-MM-dd HH:mm"
                        />
                        <DateBox
                            style={{ marginRight: '10px' }}
                            type="datetime"
                            value={endDate}
                            onValueChanged={async (e) => await handleEndDateChange(e.value)}
                            placeholder="End Date"
                            labelMode="static"
                            label="End Date"
                            stylingMode="outlined"
                            displayFormat="yyyy-MM-dd HH:mm"
                            valueFormat="yyyy-MM-dd HH:mm"
                        />
                        <SelectBox
                            style={{ marginRight: '10px' }}
                            labelMode="static"
                            label="Floorplan"
                            items={spaces}
                            stylingMode="outlined"
                            value={selectedSpace2}
                            onValueChanged={onFloorplanValueChanged}
                            valueExpr="id"
                            displayExpr="name"
                        ></SelectBox>
                        {/* <div className="ok-btn" onClick={submitOk}>
                            OK
                        </div> */}
                        <div className='assetTab-autoUpdate'>
                            <CheckBox
                                value={checkAutoUpdate}
                                text="Auto Update"
                                // disabled={isDisableAutoUpdate}
                                stylingMode="outlined"
                                labelMode="static"
                                onValueChanged={onAutoUpdateValueChange}
                                style={{ cursor: "pointer" }}
                                className='check-auto-update'
                                visible={selectedTabIndex !== 3 && selectedTabIndex !== 4}
                            >
                            </CheckBox>
                        </div>

                        {/* <div className="assettab-uploadBtnMechanicalReport">
                            <button id="generatePdfButton" alt="Export Data" title="Export Data" type="button">
                                <img
                                    src="../icons/excelNew.svg"
                                    alt="Export Data"
                                    style={{ height: '24px', width: '24px' }}
                                />
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
            <TabPanel ref={tabPanelRef}
                swipeEnabled={false}
                selectedIndex={selectedTabIndex}
                onOptionChanged={(e) => {
                    // setCheckAutoUpdate(false)
                    if (e.name === "selectedIndex") {
                        setSelectedTabIndex(e.value);
                        setCheckAutoUpdate(false)

                    }
                }}>
                <Item title="History" >
                    <AssetViewMultiple
                        assetIds={ids}
                        assetName={pageName}
                        // onSpaceLoad={(spaces)=>setSpaces(spaces)}
                        startDate={filters.startDate}
                        endDate={filters.endDate}
                        selectedTabIndex={selectedTabIndex}
                        selectedSpace={filters.selectedSpace}
                        floorplanGeo={floorplanGeo}
                        isPoll={checkAutoUpdate}
                    // dwellTime={(dTime)=>setLatestDwellTime(dTime)}
                    // dwellTime={handleDwellTime}
                    />
                </Item>
                <Item title="Edit" visible={ids.length === 1}>
                    <div className="chart-row-three">
                        <EditTab
                            assetId={ids[0]}
                        />
                    </div>
                </Item>
                <Item title="Actions" visible={ids.length === 1}>
                    <div className="chart-row-three">
                        <ActionsTab
                            assetId={ids[0]}
                        />
                    </div>
                </Item>
                <Item title="Utilization" visible={isUtilizationVisible}>
                    {/* <Item title="Utilization" visible={true}> */}
                    {console.log("selectedTabIndex",selectedTabIndex)}
                    <UtilizationHeatMap
                        assetId={ids[0]}
                        assetName={pageName}
                        spaces={spaces}
                        tenant={tenant}
                        startDate={filters.startDate}
                        endDate={filters.endDate}
                        // dateRange={dateRange}
                        // onDateChange={(dateRange) => setDateRange(dateRange)}
                        isActive={selectedTabIndex === 3}
                    // assetType={assetType}
                    />
                </Item>
                <Item title="Telemetry" visible={isTelemetryVisible}>
                    <div className="chart-row-three">
                        <CyclesChart
                            assetIds={ids}
                            startDate={filters.startDate}
                            endDate={filters.endDate}
                        />
                    </div>
                </Item>
            </TabPanel>
            <Toast
                setParentToastConfig={setToastConfig}
                toastBody={toastConfig}
            />
            <LoadingPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                showPane={true}
                shading={true}
                closeOnOutsideClick={false}
            />
        </>
    );
}